import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { accordionData } from "../data/dataTwo";
import { FaRegEnvelope } from "react-icons/fa";
import { BiBookAlt } from "react-icons/bi";
import { MdKeyboardArrowRight } from "react-icons/md";
import CustomFooter from "../component/Footer/customFooter";
import { TypeAnimation } from "react-type-animation";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import { motion, useScroll, useTransform } from "motion/react";

import "../../node_modules/tiny-slider/dist/tiny-slider.css";
import notification from "../assets/new-images/notification-list.jpg";
import ab02 from "../assets/new-images/ab02.jpg";
import ab01 from "../assets/new-images/ab01.jpg";
import sales_chart from "../assets/new-images/sales-chart.jpg";

import "../../node_modules/react-modal-video/css/modal-video.css";
import hand_with_mobile from "../assets/new-images/hand-with-mobile.png";
import taskIcon from "../assets/new-images/taskicon.png";
import "../../node_modules/react-modal-video/css/modal-video.css";
import CustomPricing from "../component/customPricing";
import ContactInTouch from "../component/contactInTouch";
import favicon from "../assets/new-images/favicon.png";
import calender from "../assets/new-images/calender.png";
import chat from "../assets/new-images/chat.png";
import dashboard from "../assets/new-images/dashboards.png";
import documents from "../assets/new-images/document.png";
import notifications from "../assets/new-images/notifications.png";
import building from "../assets/new-images/building2.svg";
import teams from "../assets/new-images/team.png";
import bulkUpload from "../assets/new-images/bulk-upload.png";
import SlidingTextWithImage from "../component/SlidingTextWithImage";
import HeaderMenu from "../component/Navbar/headermenu";
import TabsGif from "../component/Tabs";
import HomeHero from "../assets/new-images/homepage-hero.gif";
import AppStore from "../assets/new-images/app.jpg";
import PlayStore from "../assets/new-images/play.png";
import CheckIn_CheckOut from "../component/CheckIn_CheckOut/CheckIn_CheckOut";
import AttioFeaturesSection from "./AttioFeaturesSection";
import Onboard from "../OnBoard/Onboard";
import SectionRevenueBleeding from "../OnBoard/RevenueLeakSection";
import TaskStand from "../OnBoard/TaskStand";
import AISBoothModal from "../component/AISBoothModal";
import { MdOpenInNew } from "react-icons/md";
import { HomeStructuredData } from "../config/StructuredData";
import ais2026 from "../assets/new-images/ais2026.png";
// import ais2026 from "../assets/new-images/ais.png";

// import aisLogo from "../assets/new-images/ais.png";

export default function HomePage() {
  useEffect(() => {
    document.documentElement.setAttribute("dir", "ltr");
    document.documentElement.classList.add("light");
  }, []);

  let [activeIndex, setActiveIndex] = useState(0);
  const [isBoothModalOpen, setIsBoothModalOpen] = useState(false);

  // Prevent body scroll when modal is open
  useEffect(() => {
    if (isBoothModalOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    // Cleanup on unmount
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isBoothModalOpen]);

  let toggleAccordion = (index) => {
    if (activeIndex === index) {
      setActiveIndex(0);
    } else {
      setActiveIndex(index);
    }
  };
  const navigate = useNavigate();

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 640);
  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 640);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const { scrollY } = useScroll();
  const heroScale = useTransform(scrollY, [0, 500], [1, 0.82]);
  const heroOpacity = useTransform(scrollY, [0, 400], [1, 0]);

  return (
    <>
      <Helmet>
        <title>
          Simplifyte | Workflow Management Software for CA Firms &amp;
          Professional Teams
        </title>
        <meta
          name="description"
          content="Simplifyte helps CA firms, tax consultants, advocates and professional service teams manage client-wise work, FY/period tracking, documents, deadlines, reviews, approvals, reminders and closure proof."
        />
        <meta
          name="keywords"
          content="workflow management software CA firms, workflow software tax consultants, client wise work tracking, FY period tracking, document collection software, review approval workflow, deadline reminders CA, audit trail software, closure proof workflow, professional service team software India"
        />
        <meta
          property="og:title"
          content="Simplifyte | Workflow Management Software for CA Firms &amp; Professional Teams"
        />
        <meta
          property="og:description"
          content="Simplifyte helps CA firms, tax consultants, advocates and professional service teams manage client-wise work, FY/period tracking, documents, deadlines, reviews, approvals, reminders and closure proof."
        />
        <meta property="og:url" content="https://www.simplifyte.com/" />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://www.simplifyte.com/preview.jpg"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Simplifyte | Workflow Management Software for CA Firms &amp; Professional Teams"
        />
        <meta
          name="twitter:description"
          content="Simplifyte helps CA firms, tax consultants, advocates and professional service teams manage client-wise work, FY/period tracking, documents, deadlines, reviews, approvals, reminders and closure proof."
        />
        <link rel="canonical" href="https://www.simplifyte.com/" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Helmet>
      <HomeStructuredData />
      <div
        style={{
          background:
            "radial-gradient(ellipse 80% 50% at 10% -10%, rgba(9, 58, 91, 0.12) 0%, transparent 60%), radial-gradient(ellipse 70% 40% at 90% 110%, rgba(42, 156, 215, 0.1) 0%, transparent 55%), #ffffff",
        }}
      >
        <HeaderMenu />

        {/* ── SCROLL WRAPPER ── */}
        <div style={{ position: "relative" }}>
          {/* ── STICKY HERO ── */}
          <div
            style={
              isMobile
                ? { paddingTop: "24px", paddingBottom: "16px" }
                : {
                    position: "sticky",
                    top: 0,
                    zIndex: 0,
                    height: "clamp(420px, 60vw, 560px)",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    paddingTop: "clamp(30px, 5vw, 60px)",
                  }
            }
          >
            <motion.div
              className="w-full"
              style={
                isMobile
                  ? {}
                  : {
                      scale: heroScale,
                      opacity: heroOpacity,
                      transformOrigin: "50% 40%",
                    }
              }
            >
              <div className="container">
                <div
                  className="flex flex-col items-center text-center"
                  style={{ marginTop: isMobile ? "40px" : "55px" }}
                >
                  {/* AIS badge pill */}
                  <style>{`
                    @keyframes ais-border-spin {
                      0%   { background-position: 0% 50%; }
                      50%  { background-position: 100% 50%; }
                      100% { background-position: 0% 50%; }
                    }
                    .ais-pill-border {
                      background: linear-gradient(270deg, #093a5b, #1a8fe3, #7dd3fc, #093a5b);
                      background-size: 300% 300%;
                      animation: ais-border-spin 3s ease infinite;
                      border-radius: 9999px;
                      padding: 1.5px;
                      margin-bottom: 1.75rem;
                      margin-top: 1rem;
                    }
                    .ais-pill-inner {
                      display: inline-flex;
                      align-items: center;
                      gap: 10px;
                      background: #f0f6fb;
                      border-radius: 9999px;
                      padding: 8px 16px;
                    }
                    @media (max-width: 640px) {
                      .ais-pill-border {
                        max-width: 92vw;
                      }
                      .ais-pill-inner {
                        gap: 6px;
                        padding: 6px 10px;
                        border-radius: 9999px;
                        flex-wrap: nowrap;
                        white-space: nowrap;
                      }
                      .ais-pill-inner img {
                        flex-shrink: 0;
                        height: 16px;
                      }
                      .ais-pill-text {
                        white-space: nowrap;
                        font-size: 9px !important;
                        letter-spacing: 0 !important;
                      }
                    }
                  `}</style>
                  <motion.div
                    whileHover={{ scale: 1.03 }}
                    whileTap={{ scale: 0.97 }}
                    transition={{ duration: 0.15 }}
                    className="ais-pill-border cursor-pointer"
                    onClick={() => setIsBoothModalOpen(true)}
                  >
                    <div className="ais-pill-inner shadow-sm">
                      <img
                        src={ais2026}
                        alt="AIS 2026"
                        className="h-5 w-auto object-contain"
                      />
                      <span className="ais-pill-text text-[11px] font-semibold text-[#093a5b] tracking-wide">
                        Technology Partner · ICAI AI Innovation Summit 2026
                      </span>
                      <span className="text-[11px] text-[#093a5b]/50">→</span>
                    </div>
                  </motion.div>

                  <h1
                    className="font-bold text-[#0a0a0a]"
                    style={{
                      fontSize: isMobile ? "clamp(1.75rem, 10.5vw, 2.2rem)" : "clamp(2.8rem, 5.5vw, 5rem)",
                      lineHeight: 1.08,
                      letterSpacing: "-0.025em",
                      maxWidth: "820px",
                    }}
                  >
                    Work, Simplified.
                    <br />
                    <span
                      style={{
                        background:
                          "linear-gradient(90deg, #093a5b 0%, #2a7aab 100%)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        backgroundClip: "text",
                      }}
                    >
                      Every Byte of It.
                    </span>
                  </h1>

                  <p
                    className="mt-5 text-slate-400 text-[20px] max-w-lg"
                    style={{ lineHeight: 1.8 }}
                  >
                    One workspace to assign, approve, and close work —
                    <br className="hidden sm:block" /> without follow-up chaos.
                  </p>

                  <div className="mt-8 flex flex-wrap gap-3 justify-center">
                    <button
                      onClick={() =>
                        (window.location.href =
                          "https://app.simplifyte.com/login")
                      }
                      className="py-3 px-7 inline-flex items-center gap-2 font-semibold text-[15px] text-white bg-[#093a5b] hover:bg-[#0b4d7a] rounded-xl transition-all duration-300 shadow-lg hover:shadow-xl"
                    >
                      <FaRegEnvelope /> Get Started
                    </button>
                    <button
                      onClick={() => navigate("/contactsales")}
                      className="py-3 px-7 inline-flex items-center gap-2 font-semibold text-[15px] text-[#093a5b] border border-[#093a5b]/25 hover:border-[#093a5b]/60 hover:bg-[#f0f6fb] rounded-xl transition-all duration-300"
                    >
                      <BiBookAlt /> Request a demo
                    </button>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
          {/* end sticky hero */}

          {/* ── CONTENT slides up over sticky hero on scroll ── */}
          <div
            style={
              isMobile
                ? { background: "transparent" }
                : {
                    position: "relative",
                    zIndex: 1,
                    marginTop: "0px",
                    borderRadius: "0",
                    background: "transparent",
                  }
            }
          >
            <TabsGif />
            <motion.section
              className="Simplified_workFlow"
              initial={{ opacity: 0, y: +50 }}
              // whileInView={{ opacity: 1, y: 0 }}
              // initial={{ rotate: -10 }}
              // whileInView={{ rotate: 0 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, ease: "easeOut" }}
            >
              <div className="container relative mt-16">
                <div className="grid grid-cols-1 justify-center text-center">
                  <div className="">
                    <h2 className="Simplified_Text">
                      Simplify your workflow with
                      <br />
                      <TypeAnimation
                        sequence={[
                          " Dashboards",
                          1750,
                          " Tasks",
                          1750,
                          " Documents",
                          1750,
                          " Reminders",
                          1750,
                        ]}
                        wrapper="span"
                        speed={50}
                        className="typewrite text-[#093A5B]"
                        repeat={Infinity}
                      />
                    </h2>
                    <p className="Simplified_workFlow_Para">
                      An unique / novel platform designed to simplify your
                      workflow, enhance collaboration and keep your team
                      aligned—so that you can focus on what truly matters.
                    </p>
                  </div>
                </div>

                <div className="grid md:grid-cols-12 grid-cols-1 items-center gap-[30px] relative">
                  <div className="lg:col-span-4 md:col-span-12">
                    <motion.div
                      initial={{ opacity: 0, y: +50 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      // animate={{ opacity: 1, y: 0 }}
                      transition={{ duration: 1, ease: "easeOut" }}
                      className="grid lg:grid-cols-1 md:grid-cols-2 grid-cols-1 gap-[30px]"
                    >
                      <motion.div
                        className="feature-section px-6 py-10 shadow hover:shadow-md dark:shadow-gray-800 dark:hover:shadow-gray-700 transition
                   duration-500 rounded-2xl bg-white dark:bg-slate-900 cursor-pointer"
                        onClick={() => navigate("/features/team-workflow")}
                        // initial={{ rotate: -10 }}
                        // whileInView={{ rotate: 0 }}
                        // initial={{ opacity: 0, x: -100 }}
                        // whileInView={{ opacity: 1, x: 0 }}
                        // transition={{ duration: 1, ease: "easeOut" }}
                      >
                        <img
                          className="zoom-animation"
                          src={teams}
                          alt="Simplifyte"
                        />
                        <div className="content mt-7">
                          <h2 className="title h5 text-base font-semibold hover:text-indigo-600 text-[#093A5B]">
                            Team Collaboration [Seamless]
                          </h2>
                          <p className="text-slate-400 mt-3 text-[14px] font-normal">
                            AI-driven recommendations help assign tasks to the
                            right team members and streamline workflows.
                          </p>
                        </div>
                      </motion.div>

                      <div
                        className="feature-section px-6 py-10 shadow hover:shadow-md dark:shadow-gray-800
                   dark:hover:shadow-gray-700 transition duration-500 rounded-2xl bg-white dark:bg-slate-900 cursor-pointer"
                        onClick={() =>
                          navigate("/features/document-management")
                        }
                      >
                        <img
                          className="zoom-animation"
                          src={documents}
                          alt="Simplifyte"
                        />
                        <div className="content mt-7">
                          <h2 className="title h5 text-base font-semibold hover:text-indigo-600 text-[#093A5B]">
                            {/* All Your  */}
                            Documents [Organized]
                          </h2>
                          <p className="text-slate-400 mt-3 text-[14px] font-normal">
                            Smart document search, auto-folder creation and
                            auto-tagging ensure you find what you need in
                            seconds.
                          </p>
                        </div>
                      </div>
                      <div
                        className="feature-section px-6 py-10 shadow hover:shadow-md dark:shadow-gray-800
                  dark:hover:shadow-gray-700 transition duration-500 rounded-2xl bg-white dark:bg-slate-900 cursor-pointer"
                        onClick={() => document.getElementById("quick-action-section")?.scrollIntoView({ behavior: "smooth" })}
                      >
                        <img
                          className="zoom-animation"
                          src={chat}
                          alt="Simplifyte"
                        />

                        <div className="content mt-7">
                          <h2 className="title h5 text-base font-semibold hover:text-indigo-600 text-[#093A5B]">
                            {/* Just Temporary because of the Messaging is not Ready that way */}
                            {/* Messaging [Instant] */}
                            Quick Action [Simplified]
                          </h2>
                          <p className="text-slate-400 mt-3 text-[14px] font-normal">
                            {/* Stay connected with real-time chat, making team
                        communication faster and more efficient. */}
                            Simplify your workflow with quick, intuitive actions
                            that help you get things done faster.
                          </p>
                        </div>
                      </div>
                    </motion.div>
                  </div>
                  <div className="lg:col-span-4 md:col-span-12">
                    <motion.div
                      initial={{ opacity: 0, y: +50 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      // animate={{ opacity: 1, y: 0 }}
                      transition={{ duration: 1, ease: "easeOut" }}
                      className="grid lg:grid-cols-1 md:grid-cols-2 grid-cols-1 gap-[30px]"
                    >
                      <div
                        className="feature-section px-6 py-10 shadow hover:shadow-md dark:shadow-gray-800 dark:hover:shadow-gray-700 transition duration-500 
                  rounded-2xl bg-white dark:bg-slate-900 cursor-pointer"
                        onClick={() => navigate("/features/custom-dashboard")}
                      >
                        <img
                          className="zoom-animation"
                          src={dashboard}
                          alt="Simplifyte"
                        />

                        <div className="content mt-7">
                          <h2 className="title h5 text-base font-semibold hover:text-indigo-600 text-[#093A5B]">
                            Custom Dashboards [Your Way]
                          </h2>
                          <p className="text-slate-400 mt-3 text-[14px] font-normal">
                            Create multiple dashboards with AI-powered insights
                            and customizable widgets to visualize your workflow
                            effortlessly.
                          </p>
                        </div>
                      </div>
                      <div
                        className="feature-section px-6 py-10 shadow hover:shadow-md dark:shadow-gray-800 dark:hover:shadow-gray-700 
                  transition duration-500 rounded-2xl bg-white dark:bg-slate-900 cursor-pointer"
                        onClick={() => navigate("/features/task-management")}
                      >
                        <img
                          className="zoom-animation"
                          src={taskIcon}
                          alt="Simplifyte"
                        />
                        <div className="content mt-7">
                          <h2 className="title h5 text-base font-semibold hover:text-indigo-600 text-[#093A5B]">
                            Task Management [Effortless ]
                          </h2>
                          <p className="text-slate-400 mt-3 text-[14px] font-normal">
                            Organize, track, and complete tasks with a
                            clutter-free, innate interface built for
                            productivity.
                          </p>
                        </div>
                      </div>
                    </motion.div>
                  </div>
                  <div className="lg:col-span-4 md:col-span-12">
                    <motion.div
                      initial={{ opacity: 0, y: +50 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      // animate={{ opacity: 1, y: 0 }}
                      transition={{ duration: 1, ease: "easeOut" }}
                      className="grid lg:grid-cols-1 md:grid-cols-2 grid-cols-1 gap-[30px]"
                    >
                      <div
                        className="feature-section px-6 py-10 shadow hover:shadow-md dark:shadow-gray-800
                   dark:hover:shadow-gray-700 transition duration-500 rounded-2xl bg-white dark:bg-slate-900 cursor-pointer"
                        onClick={() => navigate("/features/smart-scheduling")}
                      >
                        <img
                          className="zoom-animation"
                          src={calender}
                          alt="Simplifyte"
                        />

                        <div className="content mt-7">
                          <h2 className="title h5 text-base font-semibold hover:text-indigo-600 text-[#093A5B]">
                            Scheduling & Calendar [Smart]
                          </h2>
                          <p className="text-slate-400 mt-3 text-[14px] font-normal">
                            Plan meetings, track events, and sync your schedule
                            seamlessly across your team.
                          </p>
                        </div>
                      </div>

                      <div
                        className="feature-section px-6 py-10 shadow hover:shadow-md dark:shadow-gray-800
                   dark:hover:shadow-gray-700 transition duration-500 rounded-2xl
                    bg-white dark:bg-slate-900 cursor-pointer"
                        onClick={() => navigate("office-hub")}
                      >
                        <img
                          className="zoom-animation"
                          src={building}
                          alt="Simplifyte"
                        />

                        <div className="content mt-7">
                          <h2 className="title h5 text-base font-semibold hover:text-indigo-600 text-[#093A5B]">
                            Office Hub [Simplified]
                          </h2>
                          <p className="text-slate-400 mt-3 text-[14px] font-normal">
                            Manage requests, attendance, and timesheets in one
                            centralized hub. Submit leave requests, track
                            attendance logs, and manage timesheets seamlessly
                            for both employees and managers.
                          </p>
                        </div>
                      </div>
                      <div
                        className="feature-section px-6 py-10 shadow hover:shadow-md dark:shadow-gray-800 dark:hover:shadow-gray-700 
                  transition duration-500 rounded-2xl bg-white dark:bg-slate-900 cursor-pointer"
                        onClick={() => navigate("/bulkActionsCoherent")}
                      >
                        <img
                          className="zoom-animation"
                          src={bulkUpload}
                          alt="Simplifyte"
                        />
                        <div className="content mt-7">
                          <h2 className="title h5 text-base font-semibold hover:text-indigo-600 text-[#093A5B]">
                            Bulk Actions Coherent [Simplified]
                          </h2>
                          <p className="text-slate-400 mt-3 text-[14px] font-normal">
                            AI-enhanced bulk uploads auto-classify and validate
                            data for Perfect integration.
                          </p>
                        </div>
                      </div>
                    </motion.div>
                  </div>

                  <div className="home-squere overflow-hidden after:content-[''] after:absolute after:h-40 after:w-40 after:bg-red-600/5 after:top-2/4 after:start-0 after:-z-1 after:rounded-3xl after:animate-[spin_10s_linear_infinite]"></div>
                  <div className="home-circle overflow-hidden after:content-[''] after:absolute after:size-[512px] after:bg-indigo-600/5 after:top-1/4 after:end-0 after:-z-1 after:rounded-full"></div>
                </div>
              </div>
            </motion.section>

            <SectionRevenueBleeding />
            <SlidingTextWithImage />
            <CheckIn_CheckOut />

            <TaskStand />

            {/* section className="relative md:py-24 py-16" id="features" */}
            {/* <section className="relative" id="features">
          <div className="container Transform_Your_Workflow">
            <div className="grid grid-cols-1 pb-8 text-center">
              <div className="">
                <div className="flex items-center justify-center rounded-2xl mx-auto shadow dark:shadow-gray-800 size-[110px] mt-10">
                  <img
                    src={favicon}
                    className="home-favicon block mx-auto"
                    alt="Simplifyte"
                  />
                </div>
              </div>
              <h3 className="Transform_Your_Workflow_head">
                Transform Your Workflow <br />
                for Optimal{" "}
                <span className="after:absolute after:end-0  after:start-0  after:bottom-1 after:lg:h-3 after:h-2 after:w-auto after:rounded-xl after:bg-[#093A5B]/30 relative text-indigo-600">
                  Performance
                </span>
              </h3>
            </div>
          </div>

          <div className="container relative md:mt-24 mt-16"> */}
            {/* <div className="grid md:grid-cols-2 grid-cols-1 gap-[30px] lg:items-center items-end">
              <div className="mb-8">
                <h4 className="font-size-same mb-6 md:text-3xl text-2xl md:leading-normal leading-normal font-semibold">
                  Everything Your Team <br />
                  Needs, is catered by us at one place
                </h4>
                <p className="text-slate-400 max-w-xl mx-auto">
                  From task management to client collaboration, discover how
                  Simplifyte simplifies every aspect of your workflow on Web and
                  The Simplifyte Mobile App ( Android & iOS){" "}
                </p>

                <div className="mt-6 flex sm:flex-row gap-4">
                  <a href="#" target="_blank" rel="noopener noreferrer">
                    <img
                      src={AppStore}
                      alt="Download on the App Store"
                      className="h-12"
                    />
                  </a>
                  <a href="#" target="_blank" rel="noopener noreferrer">
                    <img
                      src={PlayStore}
                      alt="Download on the Play Store"
                      className="h-12"
                    />
                  </a>
                </div>
              </div>

              <div className="">
                <img src={hand_with_mobile} className="" alt="Simplifyte" />
              </div>
            </div> */}
            {/* </div>
        </section> */}
            <AttioFeaturesSection favicon={favicon} />

            <section className="relative">
              <div className="container relative md:mt-24 mt-16 mb-16 ">
                <CustomPricing />
              </div>
            </section>

            {/* <section
          className="relative overflow-hidden"
          style={{ display: "none" }}
        >
          <div className="container relative md:mt-24 mt-16">
            <div className="grid md:grid-cols-2 grid-cols-1 items-center gap-[30px]">
              <div className="relative order-1 md:order-2">
                <div className="grid grid-cols-12 items-center gap-4 lg:gap-0">
                  <div className="col-span-6">
                    <div className="grid grid-cols-1 lg:gap-6 gap-4">
                      <img
                        src={notification}
                        className="shadow rounded-xl lg:max-w-[240px] mx-auto"
                        alt="Simplifyte"
                      />
                      <img
                        src={ab02}
                        className="shadow rounded-xl lg:max-w-[240px] mx-auto"
                        alt="Simplifyte"
                      />
                    </div>
                  </div>

                  <div className="col-span-6">
                    <div className="grid grid-cols-1">
                      <img
                        src={ab01}
                        className="shadow rounded-xl lg:max-w-[240px] mx-auto"
                        alt="Simplifyte"
                      />
                    </div>
                  </div>
                </div>
                <div className="overflow-hidden absolute md:size-[500px] size-[400px] bg-gradient-to-tl to-indigo-600/20 via-indigo-600/70 from-indigo-600 bottom-1/2 translate-y-1/2 md:start-0 start-1/2 ltr:md:translate-x-0 ltr:-translate-x-1/2 rtl:md:translate-x-0 rtl:translate-x-1/2 -z-1 shadow-md shadow-indigo-600/10 rounded-full"></div>

                <div className="absolute flex justify-between items-center md:bottom-16 bottom-0 end-5 rounded-lg shadow-md dark:shadow-gray-800 lg:w-72 w-48 m-3">
                  <img
                    src={sales_chart}
                    className="rounded-lg shadow dark:shadow-gray-800"
                    alt="Simplifyte"
                  />
                </div>
              </div>

              <div className="lg:me-8 order-2 md:order-1">
                <h4 className="mb-4 md:text-3xl text-2xl lg:leading-normal leading-normal font-semibold">
                  If you need help, <br /> we're here for you
                </h4>

                <div
                  id="accordion-collapseone"
                  data-accordion="collapse"
                  className="mt-6"
                >
                  {accordionData.slice(0, 11).map((item, index) => (
                    <div
                      key={index}
                      className="relative shadow dark:shadow-gray-800 rounded-xl overflow-hidden mt-4"
                    >
                      <h2
                        className="text-base font-semibold"
                        id="accordion-collapse-heading-1"
                      >
                        <button
                          type="button"
                          onClick={() => toggleAccordion(index)}
                          className="flex justify-between items-center p-5 w-full font-medium text-start"
                          data-accordion-target="#accordion-collapse-body-1"
                          aria-expanded="true"
                          aria-controls="accordion-collapse-body-1"
                        >
                          <span>{item.title}safwan</span>
                          <svg
                            data-accordion-icon
                            className={`${
                              activeIndex === index
                                ? "rotate-180"
                                : "rotate-270"
                            } size-4 shrink-01`}
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                              clipRule="evenodd"
                            ></path>
                          </svg>
                        </button>
                      </h2>
                      {activeIndex === index && (
                        <div>
                          <div className="p-5">
                            <p className="text-slate-400 dark:text-gray-400">
                              {item.content}
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>

                <div className="mt-4">
                  <Link
                    to="/page-aboutus"
                    className="relative inline-flex items-center font-semibold tracking-wide align-middle text-base text-center border-none after:content-[''] after:absolute after:h-px after:w-0 hover:after:w-full after:end-0 hover:after:end-auto after:bottom-0 after:start-0 after:duration-500 text-indigo-600 hover:text-indigo-600 after:bg-indigo-600 duration-500"
                  >
                    Find Out More{" "}
                    <MdKeyboardArrowRight className="text-xl ms-1" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section> */}
            <Onboard />
            {/* <ContactInTouch title={true} /> */}
            <CustomFooter />
          </div>
          {/* end content rises */}
        </div>
        {/* end scroll wrapper */}
      </div>
      {/* end page bg */}

      <AISBoothModal
        isOpen={isBoothModalOpen}
        onClose={() => setIsBoothModalOpen(false)}
      />
    </>
  );
}
